import { expVal } from '@atlassian/jira-feature-experiments';

export default {
	get(): boolean {
		return expVal('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false);
	},
};
